var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionIconThickBlack2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.5912 0 0 3.5912 0 8C0 12.4088 3.5912 16 8 16C12.4088 16 16 12.4088 16 8C16 3.5912 12.4088 0 8 0ZM8 1.6C11.5441 1.6 14.4 4.4559 14.4 8C14.4 11.5441 11.5441 14.4 8 14.4C4.4559 14.4 1.6 11.5441 1.6 8C1.6 4.4559 4.4559 1.6 8 1.6ZM8 3.2C6.232 3.2 4.8 4.632 4.8 6.4H6.4C6.4 5.52 7.12 4.8 8 4.8C8.88 4.8 9.6 5.52 9.6 6.4C9.6 8 7.2 8.2936 7.2 10.4H8.8C8.8 9.0792 11.2 8.4 11.2 6.4C11.2 4.632 9.768 3.2 8 3.2ZM7.2 11.2V12.8H8.8V11.2H7.2Z",
    fill: "#131314"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionIconThickBlack2);
export default __webpack_public_path__ + "static/media/question-icon-thick-black-2.73be86dbdb813709413f33138aca9c97.svg";
export { ForwardRef as ReactComponent };